import { format, isValid } from "date-fns";
import * as React from "react";

type RenderOrderItemTimeProps = {
  isScheduled?: boolean;
  scheduledTime?: Date | string | null;
  renderType?: "full" | "split";
};

const renderOrderItemTime = (props: RenderOrderItemTimeProps) => {
  const { isScheduled = true, scheduledTime, renderType = "full" } = props;
  if (!scheduledTime) return null;

  const date = new Date(scheduledTime);
  if (!isValid(date)) return null;

  if (renderType === "split") {
    return (
      <>
        {format(date, "MM-dd-yyyy")}
        <br />
        {format(date, "HH:mm")}
      </>
    );
  }

  return (
    <>
      {isScheduled ? "Scheduled: " : ""}
      {format(date, "MM/dd/yyyy HH:mm")}
    </>
  );
};

export { renderOrderItemTime };
